import { render, staticRenderFns } from "./GradientLegendHeader.vue?vue&type=template&id=3f115cbc&scoped=true"
import script from "./GradientLegendHeader.vue?vue&type=script&lang=ts"
export * from "./GradientLegendHeader.vue?vue&type=script&lang=ts"
import style0 from "./GradientLegendHeader.vue?vue&type=style&index=0&id=3f115cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f115cbc",
  null
  
)

export default component.exports